export default class SelectSurveysForCompare {
	static highlightMatches(text, filterSurveys) {
		const matchExists = text
			.toLowerCase()
			.includes(filterSurveys.toLowerCase());
		if (!matchExists) return text;

		const re = new RegExp(filterSurveys, "ig");
		return text.replace(re, (matchedText) => `<strong>${matchedText}</strong>`);
	}

	static filteredRows(completedSurveysDataSet, filterSurveys) {
		return completedSurveysDataSet.filter((row) => {
			const surveyGroupName = row.surveyGroupName.toString().toLowerCase();
			const year = row.year.toString().toLowerCase();
			const round = `R${row.quarter[1]}`.toString().toLowerCase();
			const avgScore = row.avgScore.toString().toLowerCase();
			const total = row.total.toString().toLowerCase();
			const searchTerm = filterSurveys.toString().toLowerCase();

			return (
				round.includes(searchTerm) ||
				avgScore.includes(searchTerm) ||
				surveyGroupName.includes(searchTerm) ||
				total.includes(searchTerm) ||
				year.includes(searchTerm)
			);
		});
	}

	static filteredDemoQuestionRows(completedSurveysDataSet, filterSurveys) {
		return completedSurveysDataSet.filter((row) => {
			const name = row.localizations["EN"].name.toString()?.toLowerCase();
			const description = row.localizations["EN"].description?.toLowerCase();
			const searchTerm = filterSurveys?.toLowerCase();

			return name.includes(searchTerm) || description.includes(searchTerm);
		});
	}
}
